/* esline-disable */
import React from 'react';
import Loadable from 'react-loadable';

const LoadingComponent = () => <div>Loading...</div>;

// Widgets
const widgets = {
  1: Loadable({
    loader: () => import('../components/widgets/Electricity/Electricity'),
    loading: LoadingComponent
  }),
  5: Loadable({
    loader: () => import('../components/widgets/SolarPV/SolarPV'),
    loading: LoadingComponent
  }),
  7: Loadable({
    loader: () => import('../components/widgets/EnergyFlow/EnergyFlow'),
    loading: LoadingComponent
  }),
  11: Loadable({
    loader: () => import('../components/widgets/SolarPV/IndustrialSolarPV'),
    loading: LoadingComponent
  }),
  12: Loadable({
    loader: () =>
        // eslint-disable-next-line import/no-cycle
      import('../components/widgets/WeatherBuildingClimate/WeatherBuildingClimate'),
    loading: LoadingComponent
  }),
  13: Loadable({
    loader: () => import('../components/widgets/Electricity/Electricity'),
    loading: LoadingComponent
  }),
  14: Loadable({
    loader: () => import('../components/widgets/SolarPV/SolarPV'),
    loading: LoadingComponent
  })
};

export default widgets;
